export const actions: any = [
  {
    title: 'Manage scheduled exports',
    action: 'export-schedule-manager',
    hidden: false,
    icon: 'timer-icon',
  },
];
